import React, { useEffect, useState } from 'react';
import { useCurrency } from '@app/currency';
import { useQuery } from '@tanstack/react-query';
import { useCustomer } from '@app/user';
import GET_PRODUCT_QUERY from '../../queries/GetProductQuery';
import AddPortfolioItemModal from './AddPortfolioItemModal';

const AddPortfolioItemModalWrapper = ({
  isModalOpen,
  setIsModalOpen,
  productId,
  action,
  setAction,
  refetch,
}) => {
  const [product, setProduct] = useState(null);
  const [configurableProductId, setConfigurableProductId] = useState(null);
  const [queryProductId, setQueryProductId] = useState<string | null>(
    productId,
  );

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const { currency } = useCurrency();
  const customer = useCustomer();

  const { data, isFetching } = useQuery(
    [
      'collection.product',
      { id: queryProductId, currency, country: customer?.marketCountry },
    ],
    GET_PRODUCT_QUERY,
    {
      refetchOnWindowFocus: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
      enabled: !!queryProductId,
    },
  );

  useEffect(() => {
    if (data?.status) {
      setError(data?.message);
    } else if (data?.Product) {
      setProduct(data.Product);
      setConfigurableProductId(data.Product.parentId || data.Product.id);
    }
  }, [data]);

  useEffect(() => {
    setLoading(isFetching);
  }, [isFetching]);

  const modalProps = {
    product,
    show: isModalOpen,
    setIsModalOpen,
    configurableProductId,
    setConfigurableProductId,
    action,
    setAction,
    setQueryProductId,
    error,
    setError,
    loading,
    setLoading,
    refetch,
  };

  return <AddPortfolioItemModal {...modalProps} />;
};

export default AddPortfolioItemModalWrapper;
